import { selectorTabbable } from '../focus/settings.js';

export const navigateDropdown = (e, container) => {
  if (!container) return;
  let list = container.querySelectorAll(selectorTabbable);
  let currentElement = container.querySelector(':focus') || list[-1];
  let currentIndex = Array.from(list).indexOf(currentElement);
  if (e.key === 'ArrowUp') {
    list[currentIndex - 1]?.focus();
  }
  if (e.key === 'ArrowDown') {
    list[currentIndex + 1]?.focus();
  }
  return;
};
